/**
 * @generated SignedSource<<4d4af45c8adaaac209629cfdbd007f03>>
 * @relayHash dd9efeee3df9ed0f25a9e443f4fe9ff1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f1dd989944ef51d82c8b883520c951c40b4af149ab99937461172b421f27efcf

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type updateHideDoneToggleMutation$variables = {
  isHideDoneEnabled: boolean;
  viewId: string;
};
export type updateHideDoneToggleMutation$data = {
  readonly jira: {
    readonly updateIssueSearchHideDonePreference: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateHideDoneToggleMutation = {
  response: updateHideDoneToggleMutation$data;
  variables: updateHideDoneToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHideDoneEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "isHideDoneEnabled",
    "variableName": "isHideDoneEnabled"
  },
  {
    "kind": "Variable",
    "name": "viewId",
    "variableName": "viewId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "updateHideDoneToggleMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
            "kind": "LinkedField",
            "name": "updateIssueSearchHideDonePreference",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "updateHideDoneToggleMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
            "kind": "LinkedField",
            "name": "updateIssueSearchHideDonePreference",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f1dd989944ef51d82c8b883520c951c40b4af149ab99937461172b421f27efcf",
    "metadata": {},
    "name": "updateHideDoneToggleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3419756ffa1072020b7cc0619420840e";

export default node;
